module.exports = __webpack_public_path__ + "img/kermel_mobile.5eb104bb.jpg";